// import React from "react";
// import ImageList from "@mui/material/ImageList";
// import ImageListItem from "@mui/material/ImageListItem";

// import glass01 from "../assets/glass-img/a-1.jpg";
// import glass02 from "../assets/glass-img/a-2.jpg";
// import glass03 from "../assets/glass-img/a-3.jpg";
// import glass04 from "../assets/glass-img/a-4.jpg";
// import glass05 from "../assets/glass-img/a-5.jpg";
// import glass06 from "../assets/glass-img/a-6.jpg";
// import glass07 from "../assets/glass-img/a-19.jpg";
// import glass08 from "../assets/glass-img/a-20.jpg";
// import glass09 from "../assets/glass-img/a-7.jpg";
// import glass10 from "../assets/glass-img/a-8.jpg";
// import glass11 from "../assets/glass-img/a-9.jpg";
// import glass12 from "../assets/glass-img/a-10.jpg";
// import glass13 from "../assets/glass-img/a-11.jpg";
// import glass14 from "../assets/glass-img/a-12.jpg";
// import glass15 from "../assets/glass-img/a-13.jpg";
// import glass16 from "../assets/glass-img/a-14.jpg";
// import glass17 from "../assets/glass-img/a-15.jpg";
// import glass18 from "../assets/glass-img/a-16.jpg";
// import glass19 from "../assets/glass-img/a-17.jpg";
// import glass20 from "../assets/glass-img/a-18.jpg";
// import glass21 from "../assets/glass-img/a-19.jpg";
// import glass22 from "../assets/glass-img/a-20.jpg";
// import glass23 from "../assets/glass-img/a-21.jpg";
// import glass24 from "../assets/glass-img/a-22.jpg";
// import glass25 from "../assets/glass-img/a-23.jpg";
// import glass26 from "../assets/glass-img/a-24.jpg";
// import glass27 from "../assets/glass-img/card-com.jpg";
// import glass28 from "../assets/glass-img/img-1.jpg";
// import glass29 from "../assets/glass-img/img-2.jpg";
// import glass30 from "../assets/glass-img/img-3.jpg";
// import glass31 from "../assets/glass-img/img-4.jpg";
// import glass32 from "../assets/glass-img/img-5.jpg";
// import glass33 from "../assets/glass-img/img-6.jpg";
// import glass34 from "../assets/glass-img/img-7.jpg";
// import glass35 from "../assets/glass-img/img-8.jpg";
// import glass36 from "../assets/glass-img/img-9.jpg";
// import glass37 from "../assets/glass-img/img-10.jpg";

// // Image data
// export const itemData = [
//   { img: glass01, title: "Image 1" },
//   { img: glass02, title: "Image 2" },
//   { img: glass03, title: "Image 3" },
//   { img: glass04, title: "Image 4" },
//   { img: glass05, title: "Image 5" },
//   { img: glass06, title: "Image 6" },
//   { img: glass07, title: "Image 7" },
//   { img: glass08, title: "Image 8" },
//   { img: glass09, title: "Image 9" },
//   { img: glass10, title: "Image 10" },
//   { img: glass11, title: "Image 11" },
//   { img: glass12, title: "Image 12" },
//   { img: glass13, title: "Image 13" },
//   { img: glass14, title: "Image 14" },
//   { img: glass15, title: "Image 15" },     
//   { img: glass16, title: "Image 16" },
//   { img: glass17, title: "Image 17" },
//   { img: glass18, title: "Image 18" },
//   { img: glass19, title: "Image 19" },
//   { img: glass20, title: "Image 20" },
//   { img: glass21, title: "Image 21" },
//   { img: glass22, title: "Image 22" },
//   { img: glass23, title: "Image 23" },
//   { img: glass24, title: "Image 24" },
//   { img: glass25, title: "Image 25" },
//   { img: glass26, title: "Image 26" },
//   { img: glass27, title: "Image 27" },
//   { img: glass28, title: "Image 28" },
//   { img: glass29, title: "Image 29" },
//   { img: glass30, title: "Image 30" },
//   { img: glass31, title: "Image 31" },
//   { img: glass32, title: "Image 32" },
//   { img: glass33, title: "Image 33" },
//   { img: glass34, title: "Image 34" },
//   { img: glass35, title: "Image 35" },
//   { img: glass36, title: "Image 36" },
//   { img: glass37, title: "Image 37" },
// ];

// export default function MosaicImageList() {
//   return (
//     <div
//       style={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         minHeight: "100vh",
//         marginTop: "50px",
//         padding: "20px",
//         backgroundColor: "#f9f9f9",
//       }}
//     >
//       <ImageList
//         sx={{
//           width: "100%",
//           maxWidth: 1200,
//           gap: 16,
//           // Responsive design: 4 images for large screens, 2 images for small screens
//           gridTemplateColumns: {
//             xs: "repeat(2, 1fr)",  // 2 images for small screens
//             sm: "repeat(3, 1fr)",  // 3 images for medium screens
//             lg: "repeat(4, 1fr)",  // 4 images for large screens
//           },
//         }}
//         rowHeight={200}
//       >
//         {itemData.map((item) => (
//           <ImageListItem
//             key={item.img}
//             style={{
//               borderRadius: "8px",
//               overflow: "hidden",
//               boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
//               transition: "transform 0.3s, box-shadow 0.3s",
//             }}
//             className="hover:scale-105 hover:shadow-lg"
//           >
//             <img
//               src={item.img}
//               alt={item.title}
//               loading="lazy"
//               style={{
//                 width: "100%",
//                 height: "100%",
//                 objectFit: "cover",
//                 transition: "transform 0.3s ease-in-out",
//               }}
//             />
//           </ImageListItem>
//         ))}
//       </ImageList>
//     </div>
//   );
// }






import React, { useState } from 'react';



// import glass01 from "../assets/glass-img/a-1.jpg";
// import glass02 from "../assets/glass-img/a-2.jpg";
// import glass03 from "../assets/glass-img/a-3.jpg";
// import glass04 from "../assets/glass-img/a-4.jpg";
// import glass05 from "../assets/glass-img/a-5.jpg";
// import glass06 from "../assets/glass-img/a-6.jpg";
import Navbar from './Navbar';
import Footer from './Footer';



import glass01 from "../assets/glass-img/a-1.jpg";
import glass02 from "../assets/glass-img/a-2.jpg";
import glass03 from "../assets/glass-img/a-3.jpg";
import glass04 from "../assets/glass-img/a-4.jpg";
import glass05 from "../assets/glass-img/a-5.jpg";
import glass06 from "../assets/glass-img/a-6.jpg";
import glass07 from "../assets/glass-img/a-19.jpg";
import glass08 from "../assets/glass-img/a-20.jpg";
import glass09 from "../assets/glass-img/a-7.jpg";
import glass10 from "../assets/glass-img/a-8.jpg";
import glass11 from "../assets/glass-img/a-9.jpg";
import glass12 from "../assets/glass-img/a-10.jpg";
import glass13 from "../assets/glass-img/a-11.jpg";
import glass14 from "../assets/glass-img/a-12.jpg";
import glass15 from "../assets/glass-img/a-13.jpg";
import glass16 from "../assets/glass-img/a-14.jpg";
import glass17 from "../assets/glass-img/a-15.jpg";
import glass18 from "../assets/glass-img/a-16.jpg";
import glass19 from "../assets/glass-img/a-17.jpg";
import glass20 from "../assets/glass-img/a-18.jpg";
import glass21 from "../assets/glass-img/a-19.jpg";
import glass22 from "../assets/glass-img/a-20.jpg";
import glass23 from "../assets/glass-img/a-21.jpg";
import glass24 from "../assets/glass-img/a-22.jpg";
import glass25 from "../assets/glass-img/a-23.jpg";
import glass26 from "../assets/glass-img/a-24.jpg";
import glass27 from "../assets/glass-img/card-com.jpg";
import glass28 from "../assets/glass-img/img-1.jpg";
import glass29 from "../assets/glass-img/img-2.jpg";
import glass30 from "../assets/glass-img/img-3.jpg";
import glass31 from "../assets/glass-img/img-4.jpg";
import glass32 from "../assets/glass-img/img-5.jpg";
import glass33 from "../assets/glass-img/img-6.jpg";
import glass34 from "../assets/glass-img/img-7.jpg";
import glass35 from "../assets/glass-img/img-8.jpg";
import glass36 from "../assets/glass-img/img-9.jpg";
import glass37 from "../assets/glass-img/img-10.jpg";

// // Image data
export const itemData = [
  { img: glass01, title: "Image 1" },
  { img: glass02, title: "Image 2" },
  { img: glass03, title: "Image 3" },
  { img: glass04, title: "Image 4" },
  { img: glass05, title: "Image 5" },
  { img: glass06, title: "Image 6" },
  { img: glass07, title: "Image 7" },
  { img: glass08, title: "Image 8" },
  { img: glass09, title: "Image 9" },
  { img: glass10, title: "Image 10" },
  { img: glass11, title: "Image 11" },
  { img: glass12, title: "Image 12" },
  { img: glass13, title: "Image 13" },
  { img: glass14, title: "Image 14" },
  { img: glass15, title: "Image 15" },     
  { img: glass16, title: "Image 16" },
  { img: glass17, title: "Image 17" },
  { img: glass18, title: "Image 18" },
  { img: glass19, title: "Image 19" },
  { img: glass20, title: "Image 20" },
  { img: glass21, title: "Image 21" },
  { img: glass22, title: "Image 22" },
  { img: glass23, title: "Image 23" },
  { img: glass24, title: "Image 24" },
  { img: glass25, title: "Image 25" },
  { img: glass26, title: "Image 26" },
  { img: glass27, title: "Image 27" },
  { img: glass28, title: "Image 28" },
  { img: glass29, title: "Image 29" },
  { img: glass30, title: "Image 30" },
  { img: glass31, title: "Image 31" },
  { img: glass32, title: "Image 32" },
  { img: glass33, title: "Image 33" },
  { img: glass34, title: "Image 34" },
  { img: glass35, title: "Image 35" },
  { img: glass36, title: "Image 36" },
  { img: glass37, title: "Image 37" },
];

const MoreGlassImages = () => {
    const [selectedImage, setSelectedImage] = useState(null); // State to hold the currently selected image

    const images = [
        glass01,
        glass02,
        glass03,
        glass04,
        glass05,
        glass06,
        glass07,
        glass08,
        glass09,
        glass10,
        glass11,
        glass12,
        glass13,
        glass14,
        glass15,
        glass16,
        glass17,
        glass18,
        glass19,
        glass20,
        glass21,
        glass22,
        glass23,
        glass24,
        glass25,
        glass26,
        glass27,
        glass28,
        glass29,
        glass30,
        glass31,
        glass32,
        glass33,
        glass34,
        glass35,
        glass36,
        glass37

        // Add the rest of the images here...
    ];

    const handleImageClick = (image) => {
        setSelectedImage(image); // Set the selected image
    };

    const handleClose = () => {
        setSelectedImage(null); // Clear the selected image
    };

    return (
        <div>

            {/* <Navbar /> */}
            <section id="work" className="py-12 bg-gray-100 mt-10">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl font-bold text-center mb-4">
                        <span className="text-purple-800">OUR GLASS GALLERY </span>
                    </h1>
                    <p className="text-center font-semibold text-blue-800 mb-8">
                        <span>We provide high standard work for your Company solutions</span>
                    </p>

                    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {images.map((image, index) => (
                            <div
                                key={index}
                                className="overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
                                onClick={() => handleImageClick(image)} // Set the image on click
                            >
                                <img
                                    src={image}
                                    alt={`Gallery Image ${index + 1}`}
                                    className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                                />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Modal to show selected image */}
                {selectedImage && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 " >
                        <div className="relative">
                            <img
                                src={selectedImage}
                                alt="Selected"
                                className="max-w-full max-h-screen rounded-lg"
                            />
                            <button
                                onClick={handleClose}
                                className="absolute top-2 right-2 text-white bg-red-600 hover:bg-red-700 rounded-full p-2"
                            >
                                ✖
                            </button>
                        </div>
                    </div>
                )}
            </section>

            {/* <Footer /> */}
        </div>
    );
};

export default MoreGlassImages;

